import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useRoe } from "./RoeLayout";
import BodyMembersTable from "@/components/BodyMembersTable";

export default function ExecutiveBodyPage() {
  const data = useRoe();
  const list = data.executive_body || [];
  return (
    <div data-testid="roe-eb-page-wrap">
      <PageHero eyebrow="About" title="Executive Body Members" />
      <PageBody>
        <BodyMembersTable members={list} theme="navy" testidPrefix="roe-eb-page" />
      </PageBody>
    </div>
  );
}
